<template>
    <van-popup v-model:show="show" style="background: rgba(0,0,0,0);" closeable close-icon="clear">
        <div class="popup-box">
            <div class="content">
                <img class="tztopbg" src="@/assets/images/tztopbg.png" alt="">
                <div class="h1">{{ props.data.title }}</div>
                <p class="con">{{ props.data.content.content }}</p>
                <van-button type="default" class="btn" @click="handleReceive">
                    {{ t('notifyPopup.a3') }}
                </van-button>
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from "vue-i18n"
import { useMainStore } from "@/store"
import { readNoticeApi } from "@/api"

const mainStore = useMainStore()
const { t } = useI18n()

const props = defineProps({
    show: Boolean,
    data: { type: Array, default: () => [] },
    type: { type: String, default: 'System' }
})
// console.log(props);


const emit = defineEmits(["update:show","receive"])

const show = ref(props.show)

watch(() => props.show, v => show.value = v)
watch(show, v => emit("update:show", v))
const read = async (idVal: string) => {
    try {
        const res = await readNoticeApi({
            id: idVal
        });
    } catch (error) {
        console.error(error);
    }
};

function handleReceive() {
    const ids = props.data.id
    read(ids)
    // mainStore.setRemark(true)
    emit("receive") 
    show.value = false
}
</script>


<style scoped lang="scss">
:deep(.van-badge__wrapper) {
    top: 50px;
    left: calc(100% - 30px);
}

.popup-box {
    width: 90vw;
    max-width: 350px;
    padding-top: 44px;

    .content {
        border-radius: 20px;
        background-color: #FFF;
        position: relative;
        padding-top: 44px;
        padding: 60px 16px 20px 16px;
        background-image: url("@/assets/images/tzbg.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top;

        .tztopbg {
            width: 90px;
            position: absolute;
            left: 0;
            right: 0;
            top: -44px;
            margin: auto;
        }

        .h1 {
            color: #000;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 12px;
        }

        .con {
            color: #666;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            word-wrap: break-word;
            /* 老写法兼容性最好 */
            word-break: break-all;
            /* 强制在任意字符断行（中文也能断） */
            white-space: normal;
            /* 允许自动换行（默认值） */
        }

        .btn {
            margin-top: 16px;
            width: 100%;
            border-radius: 10px;
            background: #2969FF;
            border-color: #2969FF;
            color: #FFF;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>